import { NestFactory } from '@nestjs/core';
import { useCaseProviders } from './usecase-providers';
import { ApplicationModule, TestMakerApplicationConfig } from './application.module';
import { AuthenticationModule, AuthenticationConfig } from './authentication.module';
import { authenticationUseCaseProviders } from './usecase-providers/authentication.provider';
export * from './authentication.module';
export * from './application.module';

export interface UseCaseConfig {
  name: string;
  instance: any;
}
export const bootstrapDI = async (config: TestMakerApplicationConfig): Promise<UseCaseConfig[]> => {
  const app = await NestFactory.createApplicationContext(ApplicationModule.register(config), {
    abortOnError: false,
    logger: false,
  });
  const useCases = useCaseProviders.map((u) => ({
    name: u.provide,
    instance: app.get(u.provide),
  }));

  return useCases;
};

export const bootstrapAuthDI = async (config: AuthenticationConfig): Promise<UseCaseConfig[]> => {
  const app = await NestFactory.createApplicationContext(AuthenticationModule.register(config), {
    abortOnError: false,
    logger: false,
  });

  const useCases = authenticationUseCaseProviders.map((u) => ({
    name: u.provide,
    instance: app.get(u.provide),
  }));
  return useCases;
};
